// extracted by mini-css-extract-plugin
export default {"subtopicHeader":"TopicPosts-module__subtopicHeader--DuSMq","isEditing":"TopicPosts-module__isEditing--zwxXd","animatedBackground":"TopicPosts-module__animatedBackground--chED8"};